import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M2 9V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m8 16 3-3-3-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 16v-1a2 2 0 0 1 2-2h6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FolderSymlink";
const FolderSymlink = memo(themed(Icon));
export {
  FolderSymlink
};
//# sourceMappingURL=folder-symlink.js.map
